module.exports = "<svg viewBox=\"0 0 29 30\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M28.421 14.21h-15.79V2.559L28.422 0v14.21zM11.053 2.462V14.21H0V4.37L11.053 2.46zM0 15.789h11.053v11.75L0 25.865V15.79zM12.632 27.7V15.79H28.42V30l-15.79-2.3z\" fill=\"#333\" fill-rule=\"evenodd\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/windows.svg
// module id = 102
// module chunks = 0